import styled from '@emotion/styled';

export const PopupBody = styled.div`
  font-family: system-ui;
  background-color: var(--surface-overlay);
  border-radius: 8px;
  box-shadow: var(--shadow-overlay);
  box-sizing: border-box;
  max-height: 450px;
`;

export const Trigger = styled.div`
  display: flex;
  width: ${(props) => props.width ?? '100%'};
  height: ${(props) => props.height ?? '100%'};
`;
